'use client';
import React, { useEffect, useState } from 'react';
import { getMiningMachineExpires } from '../../api/getMiningMachineExpires';
import { MachineExpireEntry } from '../../types/mining/MachineExpire';

export default function MiningMachineExpires() {
  const [machineData, setMachineData] = useState<MachineExpireEntry[]>([]);

  useEffect(() => {
    getMiningMachineExpires()
      .then((response) => {
        const allExpires: MachineExpireEntry[] = response.flatMap((group) =>
          group.machineExpiresData.flat()
        );

        const sorted = allExpires.sort(
          (a, b) =>
            new Date(b.operationEnd).getTime() -
            new Date(a.operationEnd).getTime()
        );

        setMachineData(sorted);
      })
      .catch(console.error);
  }, []);

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl text-center mb-5 text-brown">
        Bányagépek hátralévő üzemideje
      </h1>
      {machineData.length > 0 && (
        <div className="flex justify-center border bg-dark-blue p-3 m-2 mx-auto">
          <table className="min-w-full divide-y divide-gray-200 table-fixed divide-gray-600">
            <thead className="bg-dark-blue text-cream">
              <tr>
                <th className="py-3 px-4 text-xs font-medium text-left uppercase">
                  Felhasználó
                </th>
                <th className="py-3 px-4 text-xs font-medium text-left uppercase">
                  Csoport
                </th>
                <th className="py-3 px-4 text-xs font-medium text-left uppercase">
                  Indulás dátuma
                </th>
                <th className="py-3 px-4 text-xs font-medium text-left uppercase">
                  Leállás dátuma
                </th>
                <th className="py-3 px-4 text-xs font-medium text-right uppercase">
                  Gépek száma
                </th>
                <th className="py-3 px-4 text-xs font-medium text-center uppercase">
                  Üzemel?
                </th>
              </tr>
            </thead>
            <tbody className="divide-y bg-dark-blue divide-gray-600">
              {machineData.map((record, idx) => (
                <tr
                  key={idx}
                  className="text-sm font-medium whitespace-nowrap text-white"
                >
                  <td className="py-4 px-4">{record?.user?.name}</td>
                  <td className="py-4 px-4">{record.groupName}</td>
                  <td className="py-4 px-4">
                    {new Date(record.startDate).toLocaleDateString()}
                  </td>
                  <td className="py-4 px-4">
                    {new Date(record.operationEnd).toLocaleDateString()}
                  </td>
                  <td className="py-4 px-4 text-right">{record.numberOfMachines}</td>
                  <td className="py-4 px-4 text-center">
                    <span
                      className={`inline-block w-3 h-3 rounded-full ${
                        record.machineTurnedOff
                          ? 'bg-red-500'
                          : 'bg-green-500'
                      }`}
                    ></span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
